import { Navigate, useParams } from 'react-router-dom';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveTarjeta } from '../../shared/components';
import { useGetTarjeta } from '@/shared/actions/erp/administration/tarjeta.actions';
import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';

export interface UpdateTarjetaPageInterface {}

const UpdateTarjetaPage: React.FC<UpdateTarjetaPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_tarjeta);
  const returnUrlTarjetaPage = ROUTER_PATHS.administration.tarjetas_nav;


  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetTarjeta(id!);

  if (isLoading || isRefetching) return <LoaderComponent />;
  if (!data?.data?.id_tarjeta) return <Navigate to={returnUrlTarjetaPage} />;

  return <SaveTarjeta titlePage="Editar Tarjeta" editTarjeta={data.data} />;
};

export default UpdateTarjetaPage;
